import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20.798 11.014 17.61 14.43 9.462 6.283l4.24-4.542a.75.75 0 0 1 1.272.709l-1.992 7.302h7.268a.75.75 0 0 1 .548 1.262M3.202 12.99 6.39 9.575l8.148 8.148-4.24 4.542a.75.75 0 0 1-1.272-.709l1.992-7.303H3.75a.75.75 0 0 1-.548-1.261m.328-10.52a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06z"
    }, null, -1)
  ])))
}
export default { render: render }